export { TagInputComponent } from './tag-input';
